var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":"格式刷","placement":"bottom","open-delay":1000}},[_c('div',{staticClass:"adsorb formatBrush",class:{
      'prohibited' : _vm.formatBrush.step === 0,
      'available'  : _vm.formatBrush.step === 1,
      'carryOutble': _vm.formatBrush.step === 2,
    },on:{"click":function($event){return _vm.formatBrushFS()},"dblclick":function($event){return _vm.formatBrushFrequency()}}},[_c('i',{staticClass:"icon-editor-brush",class:{active: _vm.formatBrush.step === 2, disabled: _vm.formatBrush.step === 0}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab28df4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/editorBtn/formatBrush.vue
// module id = null
// module chunks = 